export default {
  preview: {
    label: 'Pré-visualizar',
    tooltip: 'Pré-visualize a página de encomendas online numa nova aba.',
  },
  buttons: {
    visit_online_store: 'Loja Online',
  },
  toasts: {
    failed_to_launch_orders_portal_app: 'Falha ao iniciar o portal de pedidos',
  },
};
